import {useState} from 'react';
import {GET_AVAIL_REQ_COMPANIES} from '../queries';
import {callGqlServer} from '../../../../purchaseOrder/gqlService';

let fetchFails = 1;

export const useAvailableReqComps = () => {
  const [availableReqComps, setAvailableReqComps] = useState([]);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const controller = new AbortController();

  const fetchAvailableReqComps = async () => {
    setIsLoading(true);

    const errMsg =
      fetchFails <= 3
        ? `Problem fetching available requisition companies on attempt ${fetchFails} -- see console and server logs for details`
        : `Something's really not right with fetching available requisition companies -- contact GTS or use your home company to submit the req and let them know`;

    const fetchConfig = {
      signal: controller.signal,
      errMsg
    };

    const response = await callGqlServer(
      GET_AVAIL_REQ_COMPANIES,
      {},
      fetchConfig
    );

    let gqlData = {};
    const {data, error} = response; // real server response with error status code
    if (data) gqlData = data;
    const {errors, data: successData} = gqlData; // GraphQL data or Errors

    if (error || errors) {
      fetchFails += 1;
      const err = error ? error : errors[0].message;
      console.error('Available Req Companies Error -> ', err);
      setError(errMsg);
    }
    if (successData?.availableReqCompanies) {
      fetchFails = 0;
      setAvailableReqComps(successData.availableReqCompanies);
    }
    setIsLoading(false);
  };

  return {
    availableReqComps,
    setAvailableReqComps,
    error,
    isLoading,
    setError,
    fetchAvailableReqComps,
    cancelFetchAvailableReqComps: controller.abort
  };
};
